import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4db0zb0iws: FaireBrandEntity = {
  token: "b_4db0zb0iws",
  type: "brand",
  name: "Partners Coffee Roasters",
  avatarUrl:
    "https://cdn.faire.com/fastly/bfe3eb4e10d133dc0cd1a944f02682e1194b42d1571d8d5aeb38f8cd3a8bd71c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/358359d7860b01d1714dd395d116c6bfdffe812c1c5ce5f9d864b4a73d3f95be.png",
  logoUrl:
    "https://cdn.faire.com/fastly/bfe3eb4e10d133dc0cd1a944f02682e1194b42d1571d8d5aeb38f8cd3a8bd71c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/358359d7860b01d1714dd395d116c6bfdffe812c1c5ce5f9d864b4a73d3f95be.png",
  location: "Brookyln, NY, USA",
  minimumOrderDollars: 95,
  rating: 5,
  reviewCount: 23,
  isTopShop: true,
  isInsider: true,
  description:
    "Our story began in 2012 with an unwavering commitment to sourcing and roasting quality coffee. Since then, our partnerships with farmers, producers, baristas, roasters, businesses, and customers have helped us grow and nurture a shared coffee culture and experience. \n\nWe are only as great as the sum of our partners. As partners in coffee, we thank you for being part of this journey.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.219Z",
    importedBy: "entity-db-cli",
  },
};
